// extracted by mini-css-extract-plugin
module.exports = {"Item":"CollectionItem_Item__UlUh5","Image":"CollectionItem_Image__1llJF","Text":"CollectionItem_Text__16hm_","Title":"CollectionItem_Title__2sJgx"};